import { VersionBadge } from './VersionBadge';
import { useCurrentMap } from './useGenerationQueries';
import { GenerationReadError } from './GenerationReadError';

export function CurrentMapPanel() {
  const query = useCurrentMap();

  return (
    <section className="map-generations__panel" aria-label="Опубликованная карта">
      <h2>Опубликованная карта</h2>
      {query.isPending && <p role="status">Проверка опубликованной карты…</p>}
      {query.isError && (
        <GenerationReadError error={query.error} retry={() => { void query.refetch(); }} pending={query.isFetching} label="Повторить проверку карты" />
      )}
      {!query.isError && query.data === null && <p>Карта ещё не опубликована.</p>}
      {!query.isError && query.data && (
        <dl className="map-generations__facts">
          <dt>Версия</dt>
          <dd>{query.data.version} · <VersionBadge version={query.data.version} /></dd>
          <dt>Ревизия границ</dt>
          <dd>{query.data.geometry_revision ?? 'Не указана'}</dd>
          <dt>Зоны / регионы / тайлы</dt>
          <dd>{query.data.manifest.zone_count} / {query.data.manifest.region_count} / {query.data.manifest.tile_count}</dd>
          <dt>Масштабы</dt>
          <dd>Обзор до {query.data.manifest.overview_max_zoom}, точные границы от {query.data.manifest.exact_min_zoom}, зоны от {query.data.manifest.zone_min_zoom}</dd>
          <dt>Индекс тайлов</dt>
          <dd>{query.data.tile_index ? 'Есть' : 'Нет'}</dd>
        </dl>
      )}
    </section>
  );
}
